import { render } from "./GroupsDetailPage.vue?vue&type=template&id=29816ce6"
import script from "./GroupsDetailPage.vue?vue&type=script&lang=js"
export * from "./GroupsDetailPage.vue?vue&type=script&lang=js"
script.render = render

export default script